// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__20vlF","question":"styles_question__2DoD3","description":"styles_description__13YOk"};